import { render, staticRenderFns } from "./HdEntityContactFields.vue?vue&type=template&id=8bb86e34"
import script from "./HdEntityContactFields.vue?vue&type=script&lang=js"
export * from "./HdEntityContactFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports